import { memo } from "react";
import { Box } from "@mui/material";

import { useAppContext } from "../../../2_ksbHub/context/appContext";

import AppContentWrapper from "../../../2_ksbHub/components/AppContentWrapper";

import AskomaMain from "./AskomaMain";

/**
 * =========================================================
 * ✅ ASKOMA CONTENT
 * =========================================================
 */
function AskomaContent({ viewMode, viewOffset, zoomLevel }) {
  const { isMobile } = useAppContext();

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <Box
      sx={{
        flex: 1,
        mt: isMobile ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ✅ CONTENT */}
      <AppContentWrapper padding={false} gap={1.2} scrollable={false}>
        <AskomaMain
          viewMode={viewMode}
          viewOffset={viewOffset}
          zoomLevel={zoomLevel}
        />
      </AppContentWrapper>
    </Box>
  );
}

export default memo(AskomaContent);
